import { DataObjectData, PassportType } from '@coac-gmbh/saifty-main-apis'
import { DMP_TREE, SDSSection, SDS_TREE, TDS_TREE } from './sds'
import { getCustomPassportStructureByFieldNames } from '@/composables/usePassportsTemplates'

export interface PassportSection {
  name: string
  items: PassportItem[]
  sections: PassportSection[]
  instances?: PassportItem[][]
  instancesSections?: PassportSection[][]
}

export interface PassportSectionInstance {
  items: PassportItem[]
  sections: PassportSection[]
}

export interface PassportItem {
  name: string
  saiftyPrefix?: string
  mappingTo?: string
}

export const PASSPORTS_REQUESTS_INGREDIENTS_FROM_SUPPLIER_KEY = 'INGREDIENTS_REQUESTED'

export const INGREDIENT_PREFIX_KEY = 'INGREDIENT'

export const SDS_PASSPORT_ID = 'SDS_TEMPLATE' // NOTE: We can't to update the 'template' word to 'passport' because this ID was saved in many passports, so, it may cause many errors
export const TDS_PASSPORT_ID = 'TDS_TEMPLATE'
export const DYNAMIC_PASSPORT_ID = 'DYNAMIC_PASSPORT'
export const DMP_PASSPORT_ID = 'DMP_PASSPORT'

export interface PassportStructure {
  id: string
  name: string
  type: PassportType
  getStructure: (fieldNames?: string[]) => SDSSection[]
  isDynamic?: boolean
  envFlag?: () => boolean
}

export const HARDCODED_PASSPORTS_REGISTRY: Record<string, PassportStructure> = {
  [SDS_PASSPORT_ID]: {
    id: SDS_PASSPORT_ID,
    name: 'SDS',
    type: PassportType.Sds,
    getStructure: () => SDS_TREE,
  },
  [TDS_PASSPORT_ID]: {
    id: TDS_PASSPORT_ID,
    name: 'TDS',
    type: PassportType.Tds,
    getStructure: () => TDS_TREE,
    envFlag: () => !!window.ENV.ALLOW_TDS_PASSPORT,
  },
  [DYNAMIC_PASSPORT_ID]: {
    id: DYNAMIC_PASSPORT_ID,
    name: 'Dynamic',
    type: PassportType.Custom,
    isDynamic: true,
    getStructure: (fieldNames?: string[]) => getCustomPassportStructureByFieldNames(fieldNames || []),
    envFlag: () => !!window.ENV.ALLOW_DYNAMIC_PASSPORT,
  },
  [DMP_PASSPORT_ID]: {
    id: DMP_PASSPORT_ID,
    name: 'DMP',
    type: PassportType.Custom,
    getStructure: () => DMP_TREE,
    envFlag: () => !!window.ENV.ALLOW_DMP_PASSPORT,
  },
}

export function isHardcodedPassport(passportId: string): boolean {
  return passportId in HARDCODED_PASSPORTS_REGISTRY
}

// Returns the HardcodedPassport metadata for a given ID, or undefined if not found
export function getHardcodedPassportById(passportId: string): PassportStructure | undefined {
  return HARDCODED_PASSPORTS_REGISTRY[passportId]
}

export function getPassportStructureById(passportId: string): PassportStructure {
  return (
    getHardcodedPassportById(passportId) ?? {
      id: passportId,
      name: passportId,
      type: PassportType.Custom,
      getStructure: (fieldNames = []) => getCustomPassportStructureByFieldNames(fieldNames),
    }
  )
}

// Returns the PassportType for a hardcoded passport ID
export function getHardcodedPassportType(passportId: string): PassportType {
  return HARDCODED_PASSPORTS_REGISTRY[passportId]?.type ?? PassportType.Custom // Falls back to PassportType.Custom for unknown IDs.
}

export function getPassportByType(type: PassportType): PassportStructure | undefined {
  return Object.values(HARDCODED_PASSPORTS_REGISTRY).find((passport) => passport.type === type)
}

// Derived from the registry — backward compatible
export const DEFAULT_PASSPORT_IDS_LIST = Object.keys(HARDCODED_PASSPORTS_REGISTRY)

export const CUSTOM_PASSPORT_SUBSECTION_SPECIAL_CHARACTER = '_'

export interface IngredientData {
  id: string
  name: string
  items: DataObjectData[]
}

export interface PassportRequestIngredient {
  id: number
  NAME: string
  CAS?: string
  REACH_NO?: string
  FORMULAR?: string
  MINIMAL_COMPOSITION?: string
  MAXIMAL_COMPOSITION?: string
  AVERAGE_COMPOSITION?: string
}
